export default {"gitHash":"490b34037489926ad3069dd6bc72ead3c2aa7d42","gitHashShort":"490b340","time":1694400522855,"platform":"linux","arch":"x64"};